
import React from 'react';
import { Badge } from '@/components/ui/badge';

interface PreferencesDisplayProps {
  preferences: string[];
  preferencesCharges?: { [key: string]: number };
  showCharges?: boolean;
}

export const PreferencesDisplay: React.FC<PreferencesDisplayProps> = ({
  preferences,
  preferencesCharges = {},
  showCharges = false
}) => {
  if (preferences.length === 0) return null;

  return (
    <div className="mt-3 pt-3 border-t">
      <div className="text-xs text-gray-500 mb-2">
        Preferences {showCharges && Object.keys(preferencesCharges).length > 0 && "(with charges)"}
      </div>
      <div className="flex flex-wrap gap-1">
        {preferences.map((pref, i) => (
          <div key={i} className="flex items-center gap-1">
            <Badge variant="secondary" className="text-xs">{pref}</Badge>
            {showCharges && preferencesCharges[pref] && (
              <span className="text-xs text-green-600 font-medium">+₹{preferencesCharges[pref]}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
